import Immutable from 'seamless-immutable';

import { actions } from './actions';

const defaultState = {
  loading: true,
  vendor: null,
  error: null,
  catalog: {
    loading: true,
    page: 1,
    totalPages: 1,
    total: 0,
    products: null,
    error: null,
    limit: 10,
    search: null,
  },
};

export function reducer(state = Immutable(defaultState), action) {
  switch (action.type) {
    case actions.CLEAR: {
      return state.merge(defaultState);
    }
    case actions.LOAD_DETAILS_START: {
      return state.merge({
        loading: true,
      });
    }
    case actions.LOAD_DETAILS_SUCCESS: {
      return state.merge({
        loading: false,
        vendor: action.payload.vendor,
        error: null,
      });
    }
    case actions.LOAD_DETAILS_FAIL: {
      return state.merge({
        loading: false,
        error: action.payload.error,
        vendor: null,
      });
    }
    case actions.LOAD_CATALOG_START: {
      const { page, search } = action.payload;
      const catalog = state.catalog.merge({
        page,
        search,
        loading: true,
      });
      return state.merge({ catalog });
    }
    case actions.LOAD_CATALOG_SUCCESS: {
      const {
        products, page, totalPages, total, limit,
      } = action.payload;
      const catalog = state.catalog.merge({
        page,
        totalPages,
        total,
        limit,
        products,
        loading: false,
      });
      return state.merge({ catalog });
    }
    case actions.LOAD_CATALOG_FAIL: {
      const { error } = action.payload;
      const catalog = state.catalog.merge({
        error,
        loading: false,
      });
      return state.merge({ catalog });
    }
    default: {
      return state;
    }
  }
}

export const propTypes = {};



// WEBPACK FOOTER //
// ./src/redux/VendorDetails/reducer.js